import React from 'react'

const Contest = () => {
  return (
    <div className="text-black text-4xl font-bold text-center">
      Coming Soon.........
    </div>
  )
}

export default Contest
